import { useCallback } from 'react';
import { useRemoteConfig } from '@funtech-int/yango-shared';

import { useLocale } from '@/shared/hooks/useLocale';
import { remoteConfigScheme } from '@/app/lib/remoteConfig';
import { clientConfig } from '@/config/client';

const { clientSupportLinks: defaultSupportLinks } = clientConfig;

export const useClientSupport = () => {
    const remoteConfig = useRemoteConfig(remoteConfigScheme);
    const supportLinks = remoteConfig.get('support_links');

    const language = useLocale().lang;

    const clientSupportLink = supportLinks?.[language] ?? (defaultSupportLinks.en as string);

    const openClientSupport = useCallback(() => {
        window.open(clientSupportLink, '_blank');
    }, [clientSupportLink]);

    return { openClientSupport, clientSupportLink };
};
